import React from 'react';
import idx from 'idx';
import { graphql } from 'gatsby';

import SectionHomeContentPageTeaser from '../../../components/Section/SectionHomeContentPageTeaser';
import splitNewlineToBreak from '../../../utils/string/splitNewlineToBreak';
import { getBackgroundImage, normalizeContentPositionX, normalizeContentPositionY } from '../utils';

// Types
import { SectionHomeContentPageTeaserContainerFragment } from './__generated__/SectionHomeContentPageTeaserContainerFragment';
import { SectionWidth } from '../../../../types/sections';

export const fragment = graphql`
  fragment SectionHomeContentPageTeaserContainerFragment on CMS_Section {
    backgroundColor
    backgroundPattern
    contentPositionX
    contentPositionY
    headline
    text
    backgroundImage {
      ...SectionBackgroundImageFragment
    }
    contentPageLink {
      slug
    }
    headlineColor
    textColor
  }
`;

type Props = {
  index: number;
  isClipped: boolean;
  isCritical: boolean;
  isHiddenOnMobile: boolean;
  isNeighborClipped: boolean;
  section: SectionHomeContentPageTeaserContainerFragment;
  sectionWidth: SectionWidth;
};

const SectionHomeContentPageTeaserContainer = ({
  index,
  isClipped,
  isCritical,
  isHiddenOnMobile,
  isNeighborClipped,
  section,
  sectionWidth,
}: Props) => {
  const backgroundColor = section.backgroundColor;
  const backgroundImage = getBackgroundImage(section);
  const headline = section.headline;
  const text = section.text;

  if ((!backgroundColor && !backgroundImage) || !headline || !text) {
    return null;
  }

  const contentPageSlug = idx(section, _ => _.contentPageLink.slug) || null;
  const contentPositionX = normalizeContentPositionX(section.contentPositionX);
  const contentPositionY = normalizeContentPositionY(section.contentPositionY);
  const headlineTextColor = section.headlineColor;
  const textColor = section.textColor;

  const splitHeadline = splitNewlineToBreak(headline);
  const splitText = splitNewlineToBreak(text);

  return (
    <SectionHomeContentPageTeaser
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
      backgroundPattern={section.backgroundPattern}
      contentPositionX={contentPositionX}
      contentPositionY={contentPositionY}
      headline={headline}
      headlineTextColor={headlineTextColor}
      index={index}
      isClipped={isClipped}
      isCritical={isCritical}
      isHiddenOnMobile={isHiddenOnMobile}
      isNeighborClipped={isNeighborClipped}
      sectionWidth={sectionWidth}
      splitHeadline={splitHeadline}
      splitText={splitText}
      textColor={textColor}
      url={!!contentPageSlug ? `/${contentPageSlug}` : null}
    />
  );
};

export default SectionHomeContentPageTeaserContainer;
